var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonshotInroRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 848.774,
    height: 648.221,
    viewBox: "0 0 848.774 648.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8853",
    "data-name": "Group 8853",
    transform: "translate(-75 -216)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_92",
    "data-name": "Ellipse 92",
    cx: 321.425,
    cy: 18.88,
    rx: 321.425,
    ry: 18.88,
    transform: "translate(267.674 826.462)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M595.377,254.211h-3.458V159.481a54.826,54.826,0,0,0-54.826-54.826H336.4a54.826,54.826,0,0,0-54.826,54.826V679.17A54.826,54.826,0,0,0,336.4,734h200.7a54.826,54.826,0,0,0,54.826-54.826V321.64h3.458Z",
    transform: "translate(36.672 111.345)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M581.148,160.711V679.635A40.946,40.946,0,0,1,540.2,720.58H338.544A40.946,40.946,0,0,1,297.6,679.638V160.711a40.946,40.946,0,0,1,40.944-40.945h24.465a19.462,19.462,0,0,0,18.012,26.8H496a19.462,19.462,0,0,0,18.013-26.8H540.2a40.946,40.946,0,0,1,40.945,40.944Z",
    transform: "translate(35.775 110.499)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M574.916,589.136V705.253c0,23.551-18.331,42.643-40.945,42.644H332.312c-22.613,0-40.945-19.092-40.946-42.644v-104.8c34.963-42.745,85.514-68.292,139.39-70.444S536.913,549.3,574.916,589.136Z",
    transform: "translate(42.008 87.525)",
    fill: "#cfdceb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(622.951 566.953)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_97",
    "data-name": "Ellipse 97",
    cx: 31.151,
    cy: 31.151,
    r: 31.151,
    transform: "translate(76.58 27.554)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_624",
    "data-name": "Path 624",
    d: "M553.859,382.677l2.4,11.321,44.811-3.87-3.541-16.708Z",
    transform: "translate(-433.504 -149.093)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M0,0H36.373V14.053H14.053A14.053,14.053,0,0,1,0,0Z",
    transform: "matrix(-0.207, -0.978, 0.978, -0.207, 116.867, 268.971)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M521.294,381.432l-5.044,10.417-42.574-14.5,7.444-15.373Z",
    transform: "translate(-429.012 -148.452)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    "data-name": "Path 627",
    d: "M14.052,0H36.371V14.053H0A14.053,14.053,0,0,1,14.052,0Z",
    transform: "translate(74.546 262.05) rotate(-64.164)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_628",
    "data-name": "Path 628",
    d: "M689.76,581.184a10.141,10.141,0,0,0,12-9.893l70.208-64.73-17.435-13.5L690.965,560.97a10.195,10.195,0,0,0-1.2,20.213Z",
    transform: "translate(-681.362 -368.777)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_98",
    "data-name": "Ellipse 98",
    cx: 23.185,
    cy: 23.185,
    r: 23.185,
    transform: "translate(80.636 44.893)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_629",
    "data-name": "Path 629",
    d: "M809.1,570.968c-16.264,0-35.85-3.425-47.934-17.442l-.272-.315.283-.31c.094-.1,8.981-10.26.1-28.377l-12.206,3.754L736.93,512.241l6.731-20.191L771.2,469.867a25.252,25.252,0,0,1,13.791-5.467,75.718,75.718,0,0,0,26.228-7.47,26.343,26.343,0,0,1,12.083-2.643l.542.015a9.393,9.393,0,0,1,9.1,10.108c-1.868,24.194-5.165,82.639,4.524,102.763l.25.52-.559.142a128.483,128.483,0,0,1-28.058,3.133Z",
    transform: "translate(-684.474 -366.604)",
    fill: "#1157a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M761.806,559.04s-61.359-5.664-67.967,12.272.944,26.431,12.272,30.207,38.7,8.5,38.7,8.5l12.272-15.1,32.1,1.888s35.763,20.742,45.651,42.927a29.039,29.039,0,0,0,24.333,17.214c7.93.551,14.974-2.442,14.974-14.832,0-28.319-39.647-68.911-39.647-68.911Z",
    transform: "translate(-681.922 -372.425)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M716.486,588.537s16.048-4.72,41.535,7.552",
    transform: "translate(-683.329 -374.075)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M766.843,417.071a68.949,68.949,0,0,0,29.83,9.829l-3.144-3.767a23.1,23.1,0,0,0,7.137,1.416,7.817,7.817,0,0,0,6.372-2.982,7.269,7.269,0,0,0,.487-6.716,13.771,13.771,0,0,0-4.332-5.417,25.792,25.792,0,0,0-24.006-4.29,15.415,15.415,0,0,0-7.174,4.6,8.719,8.719,0,0,0-1.759,8.081",
    transform: "translate(-686.15 -363.78)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M795.309,396.161a71.258,71.258,0,0,1,18.065-25.038c5-4.437,10.83-8.253,17.413-9.4s14,.821,18.04,6.146c3.3,4.355,3.919,10.188,3.556,15.641s-1.582,10.856-1.466,16.316a33.481,33.481,0,0,0,47.7,29.595c-5.685,3.143-10.114,8.118-15.387,11.9S870.99,447.7,865,445.2c-6.342-2.643-9.251-9.835-11.522-16.321l-10.131-28.924c-1.722-4.917-3.53-9.98-7.044-13.825s-9.218-6.19-14.055-4.256c-3.666,1.465-6.054,4.963-8.147,8.307s-4.3,6.91-7.835,8.665-8.779.675-9.933-3.1",
    transform: "translate(-687.745 -361.401)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M803.118,573.653a10.923,10.923,0,0,1-1.2-.066,10.384,10.384,0,0,1,1.181-20.7,10.019,10.019,0,0,1,1.384.1l31.7-33.743-3.309-11.03,16.614-7.45,4.658,11.384a19.342,19.342,0,0,1-5.826,22.349l-34.89,27.753a9.626,9.626,0,0,1,.057,1.019,10.4,10.4,0,0,1-3.459,7.741A10.262,10.262,0,0,1,803.118,573.653Z",
    transform: "translate(-687.599 -369.208)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M829.986,459.044h0a8.924,8.924,0,0,1,11.921,4.867l16.4,41.388-25.487,16.992Z",
    transform: "translate(-689.687 -366.828)",
    fill: "#1157a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7745",
    "data-name": "Group 7745",
    transform: "translate(75 404.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10495",
    "data-name": "Path 10495",
    d: "M941.319,742.3l-.014-.658a76.017,76.017,0,0,0-28.425-57.246,73.758,73.758,0,0,0-15.846-9.549l-.54-.241-.092.583c-1.1,6.967-2.833,14.077-3.642,17.233l-5.422-21.159-.6-.174a14.417,14.417,0,0,0-15.39,4.917,14.664,14.664,0,0,0-1.521,16.361c1.264,2.355,2.506,4.812,3.708,7.188,4.129,8.165,8.4,16.608,14.62,23.167a45.948,45.948,0,0,0,37.06,13.825Z",
    transform: "translate(-863.575 -285.109)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10496",
    "data-name": "Path 10496",
    d: "M532.019,582.921h9.435l4.49-36.4H532.017Z",
    transform: "translate(-386.666 -135.517)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10497",
    "data-name": "Path 10497",
    d: "M766.009,745.69h29.017v-.367a11.3,11.3,0,0,0-11.293-11.294h0l-5.3-4.021-9.889,4.022h-2.533Z",
    transform: "translate(-620.988 -288.442)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10498",
    "data-name": "Path 10498",
    d: "M614.944,555.214,622.4,561l25.862-26-11-8.538Z",
    transform: "translate(-567.265 -134.393)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10499",
    "data-name": "Path 10499",
    d: "M879.5,715.506l22.923,17.79.225-.29a11.3,11.3,0,0,0-2-15.847h0l-1.722-6.426-10.278-2.886-2-1.553Z",
    transform: "translate(-838.12 -287.114)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10500",
    "data-name": "Path 10500",
    d: "M791.052,519.507s.644,9.854,1.456,23.941c.133,2.31-.652,4.82-.512,7.333.093,1.667,1.11,3.289,1.2,5.027.1,1.835-1.3,3.459-1.2,5.357.1,1.854,1.7,3.98,1.8,5.878,1.04,20.422,4.811,44.87,1.035,51.7-1.861,3.368-30.207,50.031-30.207,50.031s13.216,19.824,16.992,13.216c4.987-8.728,43.423-49.559,43.423-57.356s8.892-66.154,8.892-66.154l6.2,34.541,2.843,6.844-.893,4.018,1.837,5.422.1,5.366,1.789,9.964s-5.381,77.633-2.351,79.795,17.756,6.07,19.493,2.171,8.345-81.022,8.345-81.022,1.812-35.343,3.776-68.193c.113-1.907,1.454-4.21,1.558-6.089.123-2.181-.727-5.012-.614-7.127.123-2.426,1.2-4.135,1.3-6.457.8-17.945.925-32.086-.51-34.238-4.333-6.495-8.232-11.686-8.232-11.686s-61.925-15.16-77.52,4.323Z",
    transform: "translate(-702.557 -274.783)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10501",
    "data-name": "Path 10501",
    d: "M817.986,324.565l-14.931-.835L791.8,329.873l-31.291,177.2s31.987,14.785,51.811,9.121,40.7-5.345,40.7-5.345L837.81,341.557l-12.272-11.328Z",
    transform: "translate(-673.796 -265.683)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10502",
    "data-name": "Path 10502",
    d: "M856.961,328.595l-23.111,9.438a15.729,15.729,0,0,0-14.711,12.9l1.533,45.644,8.335,21.713-5.944,49.465,3.112,6.23-2.689,6.359c3.947,6.409,3.144,14.806.8,23.848h2.832l5.664-.944s12.47,4.329,15.024-11.219c6.687-40.7,10.463-22.764,10.463-22.764l3.292-126.278Z",
    transform: "translate(-737.681 -265.955)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10503",
    "data-name": "Path 10503",
    d: "M752.172,328.615l21.59,22.635a15.729,15.729,0,0,1,14.711,12.9l-8.925,70.189,4.189,26.932-2.3,6.107,1.666,6.9-2.61,6.313,1.888,8.5-2.832,12.272-14.16-3.776.108-10.065L761.72,350.645Z",
    transform: "translate(-601.374 -265.956)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10504",
    "data-name": "Path 10504",
    d: "M693.392,451.872,722.8,473.212a6.422,6.422,0,1,1-6.062,9.314l-39.991-21.349Z",
    transform: "translate(-470.595 -272.861)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10505",
    "data-name": "Path 10505",
    d: "M716.762,356.476c5.589,2.578,19.4,68.582,23.45,69.981s2.505,1.189,3.074,2.357.706,6.4,4.6,7.013,24.445,19.353,24.445,19.353l-5.21,17.369s-39.554-22.6-50.46-35.111-16.778-76.867-16.778-76.867l-1.116-6.42S711.172,353.9,716.762,356.476Z",
    transform: "translate(-534.813 -267.387)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10506",
    "data-name": "Path 10506",
    d: "M836.062,442.64l26.209,25.168a6.422,6.422,0,1,1-7.281,8.4L818.3,449.577Z",
    transform: "translate(-742.811 -272.344)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10507",
    "data-name": "Path 10507",
    d: "M878.014,361.543c5.184,3.319-14.514,51.466-10.691,53.407s2.319,1.521,2.722,2.756-.177,6.436,3.593,7.577S895.2,447.8,895.2,447.8l-7.54,16.491s-36.086-27.8-45.176-41.692-3.175-18.58-3.175-18.58c11.277-23.951,21.824-63.011,37.759-60.415C877.07,343.608,872.83,358.224,878.014,361.543Z",
    transform: "translate(-788.575 -266.789)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_406",
    "data-name": "Ellipse 406",
    cx: 25.305,
    cy: 25.305,
    r: 25.305,
    transform: "translate(115.682 4.536)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10508",
    "data-name": "Path 10508",
    d: "M773.635,308.383s5.573,1.528,8.817,2.379c-.168-2.413-1.213-4.673-1.744-7.034s-.416-5.138,1.339-6.8,5.409-1.018,5.692,1.381l4.462-9.54c4.25,8.748,12.939,1.293,22.413,3.5,4.833,1.139,10.89.649,13.444-3.609a15.776,15.776,0,0,1-3.57-4.283,14.413,14.413,0,0,0,4.539.575,9.514,9.514,0,0,0-4.207-7.679c-1.363-.891,2.01-4.061.821-5.177-2.439-2.277-4.076-.731-5.517-3.733a11.088,11.088,0,0,0-10.018-6.125c-4.141.1-11.562.057-13.168,3.872-5.121-3.352-12.249-2.4-17.254,1.111-4.16,2.911-8.895,11.712-9.94,16.68S771,304.054,773.635,308.383Z",
    transform: "translate(-658.272 -262.238)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10521",
    "data-name": "Path 10521",
    d: "M679.929,748.448l841.4.29c2.036,0,3.686-.5,3.686-1.124s-1.65-1.124-3.686-1.124l-841.4-.29c-2.036,0-3.687.5-3.687,1.124S677.893,748.448,679.929,748.448Z",
    transform: "translate(-676.242 -289.35)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10522",
    "data-name": "Path 10522",
    d: "M775.124,328.078a4.209,4.209,0,0,1,5.7-1.352c-1.388-1.928-.342-5.224,1.833-6.556,2.464-1.509,5.577-1.259,8.451-.959l23.559,2.461c2.716.284,5.508.589,7.926,1.859s4.407,3.748,4.267,6.475a13.553,13.553,0,0,1,5.779-.784c1.937.305,3.846,1.721,4.053,3.67.332,3.128-3.385,4.935-6.412,5.793l-16.86,4.777,1.733.37a71.814,71.814,0,0,1-32.525-4.705,15.809,15.809,0,0,1-6.423-3.983C774.551,333.214,773.827,330.268,775.124,328.078Z",
    transform: "translate(-670.656 -265.417)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8798",
    "data-name": "Group 8798",
    transform: "translate(15993.779 -14471.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8797",
    "data-name": "Group 8797",
    transform: "translate(-15539.241 14915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_52",
    "data-name": "Subtraction 52",
    d: "M11.334,22.668a11.424,11.424,0,0,1-2.284-.23A11.275,11.275,0,0,1,5,20.732,11.366,11.366,0,0,1,.891,15.746a11.271,11.271,0,0,1-.66-2.127,11.449,11.449,0,0,1-.014-4.5,11.278,11.278,0,0,1,.622-2.07A3.626,3.626,0,0,0,3.967,8.841,3.628,3.628,0,0,0,5.2,1.8,11.294,11.294,0,0,1,11.334,0a11.425,11.425,0,0,1,2.284.23,11.275,11.275,0,0,1,4.053,1.705,11.367,11.367,0,0,1,4.106,4.987,11.271,11.271,0,0,1,.66,2.127,11.447,11.447,0,0,1,0,4.568,11.275,11.275,0,0,1-1.705,4.053,11.367,11.367,0,0,1-4.987,4.106,11.271,11.271,0,0,1-2.127.66A11.424,11.424,0,0,1,11.334,22.668Zm6.584-11.441A1.676,1.676,0,0,0,16.241,12.9a3.233,3.233,0,0,1-3.229,3.229,1.678,1.678,0,1,0,0,3.355,6.53,6.53,0,0,0,2.564-.519,6.617,6.617,0,0,0,3.505-3.507A6.508,6.508,0,0,0,19.6,12.9a1.676,1.676,0,0,0-1.678-1.678Z",
    transform: "translate(8.79 8.79)",
    fill: "#111729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "pupil",
    d: "M-6.942-27A20.081,20.081,0,0,1,13.116-6.942,20.081,20.081,0,0,1-6.942,13.116,20.081,20.081,0,0,1-27-6.942,20.081,20.081,0,0,1-6.942-27Zm0,34A13.954,13.954,0,0,0,7-6.942,13.954,13.954,0,0,0-6.942-20.881,13.954,13.954,0,0,0-20.881-6.942,13.954,13.954,0,0,0-6.942,7Z",
    transform: "translate(27 27)",
    fill: "#1157a6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9850",
    "data-name": "Path 9850",
    d: "M-377.377-109.956h3.135l7.742,12.491h.047v-12.491h2.826V-93h-3.135l-7.718-12.467h-.071V-93h-2.826Zm25.6,9.737a4.364,4.364,0,0,0-.273-1.235,3.291,3.291,0,0,0-.617-1.033,3.057,3.057,0,0,0-.95-.712,2.8,2.8,0,0,0-1.247-.273,3.253,3.253,0,0,0-1.294.249,2.96,2.96,0,0,0-1,.689,3.406,3.406,0,0,0-.665,1.033,3.6,3.6,0,0,0-.273,1.282Zm-6.317,1.781a4.715,4.715,0,0,0,.2,1.377,3.4,3.4,0,0,0,.606,1.164,2.919,2.919,0,0,0,1.021.8,3.369,3.369,0,0,0,1.472.3,3.252,3.252,0,0,0,1.912-.511,3.018,3.018,0,0,0,1.081-1.532h2.565a5.1,5.1,0,0,1-.736,1.781,5.121,5.121,0,0,1-1.259,1.318,5.432,5.432,0,0,1-1.65.807,6.643,6.643,0,0,1-1.912.273,6.5,6.5,0,0,1-2.565-.475,5.3,5.3,0,0,1-1.888-1.33,5.644,5.644,0,0,1-1.164-2.042,8.3,8.3,0,0,1-.392-2.612,7.391,7.391,0,0,1,.416-2.482,6.355,6.355,0,0,1,1.187-2.066,5.679,5.679,0,0,1,1.864-1.413,5.654,5.654,0,0,1,2.47-.522,5.5,5.5,0,0,1,2.6.606,5.705,5.705,0,0,1,1.912,1.6,6.491,6.491,0,0,1,1.1,2.292,7.025,7.025,0,0,1,.178,2.672Zm19.805-1.781a4.367,4.367,0,0,0-.273-1.235,3.29,3.29,0,0,0-.617-1.033,3.058,3.058,0,0,0-.95-.712,2.8,2.8,0,0,0-1.247-.273,3.253,3.253,0,0,0-1.294.249,2.96,2.96,0,0,0-1,.689,3.408,3.408,0,0,0-.665,1.033,3.6,3.6,0,0,0-.273,1.282Zm-6.317,1.781a4.715,4.715,0,0,0,.2,1.377A3.394,3.394,0,0,0-343.8-95.9a2.919,2.919,0,0,0,1.021.8,3.369,3.369,0,0,0,1.472.3,3.252,3.252,0,0,0,1.912-.511,3.018,3.018,0,0,0,1.08-1.532h2.565a5.1,5.1,0,0,1-.736,1.781,5.121,5.121,0,0,1-1.259,1.318,5.432,5.432,0,0,1-1.65.807,6.644,6.644,0,0,1-1.912.273,6.5,6.5,0,0,1-2.565-.475,5.3,5.3,0,0,1-1.888-1.33,5.644,5.644,0,0,1-1.164-2.042,8.3,8.3,0,0,1-.392-2.612,7.391,7.391,0,0,1,.416-2.482,6.353,6.353,0,0,1,1.187-2.066,5.679,5.679,0,0,1,1.864-1.413,5.654,5.654,0,0,1,2.47-.522,5.5,5.5,0,0,1,2.6.606,5.706,5.706,0,0,1,1.912,1.6,6.49,6.49,0,0,1,1.1,2.292,7.024,7.024,0,0,1,.178,2.672ZM-321.665-93h-2.565v-1.662h-.047a3.215,3.215,0,0,1-1.591,1.532,5.39,5.39,0,0,1-2.208.463,5.863,5.863,0,0,1-2.529-.511,5.045,5.045,0,0,1-1.793-1.389,5.946,5.946,0,0,1-1.069-2.078,9.009,9.009,0,0,1-.356-2.577,8.233,8.233,0,0,1,.451-2.873,5.755,5.755,0,0,1,1.2-1.995,4.636,4.636,0,0,1,1.71-1.152,5.44,5.44,0,0,1,1.959-.368,6.56,6.56,0,0,1,1.164.107,5.126,5.126,0,0,1,1.14.344,4.5,4.5,0,0,1,1.009.606,3.358,3.358,0,0,1,.772.867h.047v-6.269h2.707Zm-9.452-6.008a5.987,5.987,0,0,0,.2,1.544,4.232,4.232,0,0,0,.617,1.354,3.124,3.124,0,0,0,1.057.95,3.082,3.082,0,0,0,1.52.356,3.04,3.04,0,0,0,1.555-.38,3.226,3.226,0,0,0,1.069-1,4.51,4.51,0,0,0,.617-1.389,6.215,6.215,0,0,0,.2-1.579,4.961,4.961,0,0,0-.914-3.182,3.012,3.012,0,0,0-2.482-1.14,3.064,3.064,0,0,0-1.6.392,3.3,3.3,0,0,0-1.069,1.021,4.242,4.242,0,0,0-.594,1.425A7.425,7.425,0,0,0-331.117-99.008Zm12.752-10.948h2.707V-93h-2.707ZM-304-100.219a4.364,4.364,0,0,0-.273-1.235,3.29,3.29,0,0,0-.617-1.033,3.057,3.057,0,0,0-.95-.712,2.8,2.8,0,0,0-1.247-.273,3.253,3.253,0,0,0-1.294.249,2.961,2.961,0,0,0-1,.689,3.407,3.407,0,0,0-.665,1.033,3.6,3.6,0,0,0-.273,1.282Zm-6.317,1.781a4.716,4.716,0,0,0,.2,1.377,3.4,3.4,0,0,0,.606,1.164,2.919,2.919,0,0,0,1.021.8,3.369,3.369,0,0,0,1.472.3,3.252,3.252,0,0,0,1.912-.511,3.018,3.018,0,0,0,1.081-1.532h2.565a5.1,5.1,0,0,1-.736,1.781,5.122,5.122,0,0,1-1.259,1.318,5.432,5.432,0,0,1-1.65.807,6.643,6.643,0,0,1-1.912.273,6.5,6.5,0,0,1-2.565-.475,5.3,5.3,0,0,1-1.888-1.33,5.644,5.644,0,0,1-1.164-2.042,8.3,8.3,0,0,1-.392-2.612,7.391,7.391,0,0,1,.416-2.482,6.353,6.353,0,0,1,1.187-2.066,5.678,5.678,0,0,1,1.864-1.413,5.654,5.654,0,0,1,2.47-.522,5.5,5.5,0,0,1,2.6.606,5.707,5.707,0,0,1,1.912,1.6,6.491,6.491,0,0,1,1.1,2.292,7.024,7.024,0,0,1,.178,2.672Z",
    transform: "translate(-15200 15071.224)",
    fill: "#111729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9849",
    "data-name": "Path 9849",
    d: "M133.749-109.956h12.206v2.565h-9.238v4.441h8.549v2.422h-8.549v4.963h9.4V-93H133.749Zm13.512,4.678h2.968l3.206,9.167h.048l3.111-9.167h2.826l-4.773,12.942q-.332.831-.653,1.591a5.694,5.694,0,0,1-.784,1.342,3.386,3.386,0,0,1-1.152.926,3.925,3.925,0,0,1-1.757.344,12.319,12.319,0,0,1-1.876-.142v-2.28q.332.048.641.107a3.388,3.388,0,0,0,.641.059,2.207,2.207,0,0,0,.784-.119,1.3,1.3,0,0,0,.511-.344,2.138,2.138,0,0,0,.344-.534,5.228,5.228,0,0,0,.261-.712l.309-.95Zm22.394,5.058a4.365,4.365,0,0,0-.273-1.235,3.29,3.29,0,0,0-.617-1.033,3.057,3.057,0,0,0-.95-.712,2.8,2.8,0,0,0-1.247-.273,3.253,3.253,0,0,0-1.294.249,2.96,2.96,0,0,0-1,.689,3.406,3.406,0,0,0-.665,1.033,3.6,3.6,0,0,0-.273,1.282Zm-6.317,1.781a4.716,4.716,0,0,0,.2,1.377,3.394,3.394,0,0,0,.606,1.164,2.919,2.919,0,0,0,1.021.8,3.369,3.369,0,0,0,1.472.3,3.252,3.252,0,0,0,1.912-.511,3.018,3.018,0,0,0,1.081-1.532H172.2a5.1,5.1,0,0,1-.736,1.781,5.122,5.122,0,0,1-1.259,1.318,5.433,5.433,0,0,1-1.65.807,6.644,6.644,0,0,1-1.912.273,6.5,6.5,0,0,1-2.565-.475,5.3,5.3,0,0,1-1.888-1.33,5.644,5.644,0,0,1-1.164-2.042,8.3,8.3,0,0,1-.392-2.612,7.391,7.391,0,0,1,.416-2.482,6.352,6.352,0,0,1,1.187-2.066,5.678,5.678,0,0,1,1.864-1.413,5.654,5.654,0,0,1,2.47-.522,5.5,5.5,0,0,1,2.6.606,5.706,5.706,0,0,1,1.912,1.6,6.49,6.49,0,0,1,1.1,2.292,7.025,7.025,0,0,1,.178,2.672Z",
    transform: "translate(-15632.308 15071.224)",
    fill: "#1157a6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonshotInroRight);
export default __webpack_public_path__ + "static/media/moonshot-inro-right.6ef45c165920db99ae3bc26596820c09.svg";
export { ForwardRef as ReactComponent };